import styled, {css} from 'styled-components'
import {Badge} from '@/components/ui/badge/Badge'

// White sub-card badge that stands out on the coloured event background
export const StyledAgendaEventSubstitutionBadge = styled(Badge)(
    ({theme: {palette, spacing}}) => css`
        align-self: flex-start;
        justify-content: flex-start;
        max-width: 100%;
        margin-bottom: ${spacing * 0.5}px;
        padding: ${spacing * 0.5}px ${spacing * 1.5}px;
        gap: ${spacing * 0.5}px;
        background: ${palette.neutral.white};
        text-align: left;
        line-height: 16px;

        & svg {
            flex-shrink: 0;
        }
    `
)
